import { lottieAnimations } from '@backrs_ui/common-ui/src/assets/lottieAnimations';

import { Box, SxProps, Theme } from '@mui/material';
import Lottie from 'lottie-react';

export const FullScreenLoading = () => {
  return (
    <Box sx={loadingContainerSx}>
      <Lottie animationData={lottieAnimations.dotsDotting} />
    </Box>
  );
};

const loadingContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100dvh',
  width: '100dvw',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 9999,
  backgroundColor: backrs.colors['Beige/25'],
});
